/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Legal_NoticeInputs */



/**
* | output |
* | --- |
* | "Legal Notice" |
*
* @param {Footer_Legal_NoticeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_legal_notice = /** @type {((inputs?: Footer_Legal_NoticeInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Legal_NoticeInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Impressum")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mentions légales")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("法律声明")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("法律聲明")
	if (locale === "ko") return /** @type {LocalizedString} */ ("법적 고지")
	return /** @type {LocalizedString} */ ("Legal Notice")
});